// Platform-specific metadata applicability rules
export const PLATFORM_METADATA_APPLICABILITY: Record<string, Record<string, 'APPLICABLE' | 'OPTIONAL' | 'NOT APPLICABLE'>> = {
  adf: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'OPTIONAL',
    market_group: 'NOT APPLICABLE',
    business_stream: 'OPTIONAL',
    business_application: 'OPTIONAL',
    to_be_deleted: 'OPTIONAL',
  },
  adb: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'APPLICABLE',
    job_name: 'OPTIONAL',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'OPTIONAL',
    market_group: 'OPTIONAL',
    to_be_deleted: 'OPTIONAL',
  },
  controlm: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'APPLICABLE',
    schedtab: 'APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
  },
  bods: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'APPLICABLE',
    schedtab: 'APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
  },
  ddh: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
  },
  sapbw: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
  },
  hwa: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
  },
  sqlagent: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
  },
  windowsserver: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
  },
  mdt: {
    env: 'APPLICABLE',
    platform_name: 'APPLICABLE',
    scheduler_name: 'APPLICABLE',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
  },
};

// Fallback for any platform not explicitly defined
export const METADATA_APPLICABILITY: Record<string, 'APPLICABLE' | 'OPTIONAL' | 'NOT APPLICABLE'> = {
  env: 'APPLICABLE',
  platform_name: 'NOT APPLICABLE',
  scheduler_name: 'NOT APPLICABLE',
  workspace_name: 'NOT APPLICABLE',
  app_name: 'NOT APPLICABLE',
  schedtab: 'NOT APPLICABLE',
  job_id: 'NOT APPLICABLE',
  job_name: 'APPLICABLE',
  sector: 'OPTIONAL',
  program: 'OPTIONAL',
  domain: 'OPTIONAL',
  gdo: 'OPTIONAL',
  source_category: 'OPTIONAL',
  source_subcategory: 'OPTIONAL',
  orchestrator: 'OPTIONAL',
  business_unit: 'OPTIONAL',
  department: 'OPTIONAL',
  capability: 'OPTIONAL',
  technology: 'OPTIONAL',
  dataasset_name: 'OPTIONAL',
  bronze_table: 'OPTIONAL',
  silver_table: 'OPTIONAL',
  gold_table: 'OPTIONAL',
  sustain_owner: 'OPTIONAL',
  sustain_prod_date: 'OPTIONAL',
  layer: 'OPTIONAL',
  market: 'OPTIONAL',
  market_group: 'OPTIONAL',
  business_stream: 'OPTIONAL',
  business_application: 'OPTIONAL',
  to_be_deleted: 'OPTIONAL',
};

export const METADATA_REQUIRED_HEADERS = [
  'env',
  'platform_name',
  'scheduler_name',
  'workspace_name',
  'app_name',
  'schedtab',
  'job_id',
  'job_name',
  'sector',
  'program',
  'domain',
  'gdo',
  'source_category',
  'source_subcategory',
  'orchestrator',
  'business_unit',
  'department',
  'capability',
  'technology',
  'dataasset_name',
  'bronze_table',
  'silver_table',
  'gold_table',
  'sustain_owner',
  'sustain_prod_date',
  'layer',
  'market',
  'market_group',
  'business_stream',
  'business_application',
  'to_be_deleted',
];

export const sampleRows = [
  {
    env: 'APPLICABLE',
    platform_name: 'adf',
    scheduler_name: 'adf',
    workspace_name: 'APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'OPTIONAL',
    market_group: 'NOT APPLICABLE',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
    to_be_deleted: 'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'adb',
    scheduler_name: 'adb',
    workspace_name: 'APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'APPLICABLE',
    job_name: 'OPTIONAL',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'OPTIONAL',
    market_group: 'OPTIONAL',
    to_be_deleted: 'OPTIONAL',
    business_application:'OPTIONAL',
    business_stream:'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'controlm',
    scheduler_name: 'controlmna',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'APPLICABLE',
    schedtab: 'APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'bods',
    scheduler_name: 'controlmpgt',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'APPLICABLE',
    schedtab: 'APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'ddh',
    scheduler_name: 'ddh',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'sapbw',
    scheduler_name: 'sapbw',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'hwa',
    scheduler_name: 'hwa',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'sqlagent',
    scheduler_name: 'sqlserver',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'windowsserver',
    scheduler_name: 'windowsserver',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
  },
  {
    env: 'APPLICABLE',
    platform_name: 'mdt',
    scheduler_name: 'mdt',
    workspace_name: 'NOT APPLICABLE',
    app_name: 'NOT APPLICABLE',
    schedtab: 'NOT APPLICABLE',
    job_id: 'NOT APPLICABLE',
    job_name: 'APPLICABLE',
    sector: 'OPTIONAL',
    program: 'OPTIONAL',
    domain: 'OPTIONAL',
    gdo: 'OPTIONAL',
    source_category: 'OPTIONAL',
    source_subcategory: 'OPTIONAL',
    orchestrator: 'OPTIONAL',
    business_unit: 'OPTIONAL',
    department: 'OPTIONAL',
    capability: 'OPTIONAL',
    technology: 'OPTIONAL',
    dataasset_name: 'OPTIONAL',
    bronze_table: 'OPTIONAL',
    silver_table: 'OPTIONAL',
    gold_table: 'OPTIONAL',
    sustain_owner: 'OPTIONAL',
    sustain_prod_date: 'OPTIONAL',
    layer: 'OPTIONAL',
    market: 'NOT APPLICABLE',
    market_group: 'NOT APPLICABLE',
    to_be_deleted: 'OPTIONAL',
    business_stream:'OPTIONAL',
    business_application:'OPTIONAL',
  },
];